module.exports = __webpack_public_path__ + "static/media/mapreduce.4f870e59.svg";